import React, { useEffect } from "react";
import classes from "./ThemesContainer.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllThemes } from "../../Books/NewBook/ThemeActions";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import SecondaryButton from "../../../components/Buttons/SecondaryButton";

function ThemesContainer() {
  const dispatch = useDispatch();
  const { allThemes, isFetched } = useSelector((state) => state.themes);

  useEffect(() => {
    if (!isFetched) {
      fetchAllThemes(dispatch);
    }
  }, [dispatch, isFetched]);

  const middle = Math.ceil(allThemes.length / 2);

  const firstHalf = allThemes.slice(0, Math.ceil(middle));
  const secondHalf = allThemes.slice(Math.ceil(middle));

  return (
    <section className={classes.main}>
      <h2>Choose Your Theme</h2>
      <div className={classes.marqueeWrapper}>
        <Marquee>
          {firstHalf.map((theme) => (
            <div className={classes.themeImageWrapper} key={theme.id}>
              <img
                src={theme.displayImage}
                width={152}
                height={176}
                loading="lazy"
                alt={theme.name}
              />
            </div>
          ))}
        </Marquee>
      </div>
      <div className={classes.marqueeWrapper}>
        <Marquee direction="right">
          {secondHalf.map((theme) => (
            <div className={classes.themeImageWrapper} key={theme.id}>
              <img
                src={theme.displayImage}
                width={152}
                height={176}
                loading="lazy"
                alt={theme.name}
              />
            </div>
          ))}
        </Marquee>
      </div>
      <div className={classes.createBtnWrapper}>
        <Link to={"/newbook"}>
          <SecondaryButton className={classes.createBtn}>Create Your Book Now</SecondaryButton>
      </Link></div>
    </section>
  );
}

export default ThemesContainer;
